'use client';

import { Dialog } from '@app/_components/ui';
import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import type { Dictionary } from 'types';

import ProductPageLargeOrderForm from './ProductPageLargeOrderForm';

type ProductPageLargeOrderButtonProps = {
    formReference?: string;
    formDictionary: Dictionary;
};

export default function ProductPageLargeOrderButton({
    formReference,
    formDictionary,
}: ProductPageLargeOrderButtonProps) {
    const [isOpen, setIsOpen] = useState(false);

    if (!formDictionary) {
        return null;
    }

    const placeOrderFormButtonTextLink =
        formDictionary.placeOrderFormButtonTextLink?.split(' ');
    const placeOrderFormButtonTextLink1 = placeOrderFormButtonTextLink
        ?.slice(0, -1)
        .join(' ');

    const placeOrderFormButtonTextLink2 = placeOrderFormButtonTextLink?.pop();

    return (
        <>
            <AnimatePresence>
                {isOpen && (
                    <Dialog.Root
                        static
                        className="fixed inset-0 z-40 overflow-y-auto"
                        open={isOpen}
                        onClose={() => setIsOpen(false)}>
                        <Dialog.Overlay />
                        <Dialog.Content
                            onClose={() => setIsOpen(false)}
                            position="center"
                            className="flex flex-col gap-4 px-4 py-6">
                            <div className="flex flex-col gap-2">
                                <Dialog.Title className="text-lg font-medium">
                                    {formDictionary.placeOrderFormHeading}
                                </Dialog.Title>
                                <Dialog.Description className="text-sm">
                                    {formDictionary.placeOrderFormDescription}
                                </Dialog.Description>
                            </div>
                            <ProductPageLargeOrderForm
                                formReference={formReference}
                                formDictionary={formDictionary}
                            />
                        </Dialog.Content>
                    </Dialog.Root>
                )}
            </AnimatePresence>
            <button
                onClick={() => setIsOpen(true)}
                type="button"
                className="gap-x-1.5 place-self-end bg-grey-100 px-4 py-2 text-left text-xs transition-colors duration-150 ease-in-out hover:bg-grey-150/50 lg:flex-row lg:text-sm">
                {formDictionary.placeOrderFormButtonText}
                {placeOrderFormButtonTextLink1 && (
                    <>
                        {' '}
                        {placeOrderFormButtonTextLink1}
                        {placeOrderFormButtonTextLink2 && (
                            <>
                                {' '}
                                <span className="underline">
                                    {placeOrderFormButtonTextLink2}
                                </span>
                            </>
                        )}
                    </>
                )}
            </button>
        </>
    );
}
